import React, { useContext } from 'react';
import _noop from 'lodash/noop';

import { ModalContext } from 'commons-ui';
import { ACTION_IDS } from './constants';
import { CreateTournamentRefundRequest } from './createTournamentRefundRequest';

export const makeActionHandler = (actionId: string, params: any) => {
	const { refundSuggestionDetails, tournamentDetails } = params;
	const { setModalConfig } = useContext(ModalContext);

	switch (actionId) {
		case ACTION_IDS.CREATE_TOURNAMENT_REFUND_REQUEST:
			return () => {
				setModalConfig({
					isOpen: true,
					header: 'Create Tournament Refund Request',
					content: (
						<CreateTournamentRefundRequest
							tournamentDetails={tournamentDetails}
							refundSuggestionDetails={refundSuggestionDetails}
						/>
					)
				});
			};
		default:
			return _noop;
	}
};

export default {
	makeActionHandler
};
